module.exports = __webpack_public_path__ + "img/valance-standard.c45c294b.svg";